module.exports = __webpack_public_path__ + "static/img/2 艺术雅宴.d48261f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/2 艺术雅宴.jpg
// module id = 07Gz
// module chunks = 1